<template>
  <div>
    <aside class="menu is-hidden-mobile">
      <ul class="menu-list">
        <li>
          <router-link to="/my-applications">
            <span class="icon">
              <i class="mdi mdi-apps mdi-18px" aria-hidden="true"></i>
            </span>
            <span>{{ $t('navbar.my_apps') }}</span>
          </router-link>
        </li>
        <li>
          <router-link to="/authfactors">
            <span class="icon">
              <i class="mdi mdi-key mdi-18px" aria-hidden="true"></i>
            </span>
            <span>{{ $t('navbar.auth_factors') }}</span>
          </router-link>
        </li>
        <li>
          <router-link to="/profile">
            <span class="icon">
              <i
                class="mdi mdi-card-account-details-outline mdi-18px"
                aria-hidden="true"
              ></i>
            </span>
            <span>{{ $t('navbar.profile') }}</span>
          </router-link>
        </li>        
        <li>
          <router-link to="/sessions">
            <span class="icon">
              <i class="mdi mdi-export mdi-18px" aria-hidden="true"></i>
            </span>
            <span>{{ $t('navbar.active_sessions') }}</span>
          </router-link>
        </li>
        <li>
          <router-link to="/settings">
            <span class="icon">
              <i class="mdi mdi-account-cog mdi-18px" aria-hidden="true"></i>
            </span>
            <span>{{ $t('navbar.settings') }}</span>
          </router-link>
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
export default {
  name: "Navbar"
};
</script>
